<template>
  <div class="container">
    <hr class="space space-sm">
    <loader v-if="isLoading"></loader>
    <div v-else>
      <div class="row align-items-center" v-if="!isLoading">
        <div class="col-md-6">
          <h1 v-if="subject">{{ subject.title }}</h1>
          <p>{{ subject.description }}</p>
          <h3>Добро пожаловать на курc!</h3>
          <p>Желаем вам успехов в обучении!</p>
        </div>
        <div class="col-md-5 offset-md-1">
          <img src="/static/images/subjects/subject.png" alt="" class="img-fluid">
        </div>
      </div>
      <hr class="space space-sm">

      <div class="row" v-if="variants && !isLoading">
        <div class="col-md-6" v-for="variant in activeVariants" :key="variant.id">
          <div class="card mb-5">
            <div class="card-body d-flex justify-content-between p-3" v-if="variant.isActive">
              <div>
                <p class="large semibold">{{ variant.title }}</p>
                <p>
                  <a href="#" @click.prevent="openQuestionsModal(variant)" class="btn btn-lg btn-success">
                    <span v-if="isFinished(variant)">Тест пройден</span>
                    <span v-else-if="isStarted(variant)">Продолжить тест</span>
                    <span v-else>Начать тест</span>
                  </a>
                </p>
              </div>
              <vc-donut v-if="isStarted(variant)" :thickness="20" :size="100" :sections="donutData(variant)" class="justify-content-start"><h4 style="margin: 0;">{{ totalAnswers(variant) }}/{{ variant.questions.length }}</h4></vc-donut>
              <!-- <div v-if="variant.questions">
                <p class="semibold truncate" v-for="(question, index) in variant.questions" :key="index">
                  <a href="#" @click.prevent="openEditQuestionModal(variant, question)">{{ index + 1 }} {{ question.question }}</a>
                </p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <questions-modal :subject="subject" :variant="activeVariant" ref="modal" @update="update"></questions-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QuestionsModal from './Includes/QuestionsModal'

export default {
  name: 'purchased-subject',
  props: ['id'],
  components: {
    QuestionsModal: QuestionsModal
  },
  data () {
    return {
      activeVariant: null,
      currentQuestion: null,
      sections: [{ value: 25 }, { value: 25 }]
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      subject: state => state.managers.subject,
      variants: state => state.managers.variants,
      isLoading: state => state.auth.loading,
      studentAnswers: state => state.students.answers
    }),
    activeVariants () {
      if (this.variants) {
        return this.variants.filter((variant) => {
          return variant.isActive
        })
      }
    }
  },
  methods: {
    openQuestionsModal (variant) {
      this.activeVariant = variant
      this.$refs.modal.toggleModal()
    },
    update () {
      this.$store.dispatch('GET_STUDENT_ANSWERS', this.id)
    },
    isStarted (variant) {
      if (this.studentAnswers && this.variants && this.studentAnswers[variant.id] && this.studentAnswers[variant.id].currentQuestion) {
        return true
      }
    },
    isFinished (variant) {
      if (this.studentAnswers && this.variants && this.studentAnswers[variant.id] && this.studentAnswers[variant.id].currentQuestion) {
        if (this.studentAnswers[variant.id].currentQuestion >= variant.questions.length) {
          return true
        }
      }
    },
    totalAnswers (variant) {
      if (this.studentAnswers && this.variants && this.studentAnswers[variant.id] && this.studentAnswers[variant.id].currentQuestion) {
        return this.studentAnswers[variant.id].currentQuestion + 1
      }
    },
    donutData (variant) {
      if (this.totalAnswers(variant)) {
        return [{ value: Number((this.totalAnswers(variant) * 100 / variant.questions.length).toFixed(1)), color: '#0E245A' }]
      } else {
        return [{ value: 0, color: '#0E245A' }]
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.activeVariant = null
  },
  created () {
    this.$store.dispatch('SET_LOADING', true)
    this.$store.dispatch('GET_SUBJECT', this.id)
    this.$store.dispatch('GET_SUBJECT_VARIANTS', this.id)
    this.$store.dispatch('GET_STUDENT_ANSWERS', this.id).then(() => {
      this.$store.dispatch('SET_LOADING', false)
    })

    if (!this.user.subjects.includes(this.id)) {
      this.$router.push({ name: 'subjects' })
    }
  }
}
</script>